module.exports = __webpack_public_path__ + "img/e_pic_register1.1766306608134.png";